export default "__VITE_ASSET__Bgi7P$Xn__"